module.exports = __webpack_public_path__ + "static/media/traycorp14.28b64939.png";